import { SubscriptionTier } from "@repo/ui/pricing-hooks";
import type { ReactNode } from "react";
import type { IntlShape } from "react-intl";

import messages from "../../../locales/messages";

const bold = (chunks: ReactNode) => <b>{chunks}</b>;

export const getWarningFeatures = (
  subscriptionTier: SubscriptionTier,
  t: IntlShape["formatMessage"]
): ReactNode[] => {
  const m = messages.CancellationWarningModal;

  const projectsLocked = t(m.FeatureProjectsLocked, { bold });
  const noTeamMembers = t(m.NoTeamMembers, { bold });
  const lowQualityExport = t(m.FeatureLowQualityExport, { bold });
  const previewOnly = t(m.FeaturePreviewOnly, { bold });
  const limitedRenders = t(m.FeatureLimitedRenders, { bold });
  const noRenders = t(m.FeatureNoRenders);
  const noVersionHistory = t(m.FeatureNoVersionHistory);
  const noCadImporters = t(m.FeatureNoCadImporters, { bold });
  const noImmersive = t(m.FeatureNoImmersive, { bold });

  switch (subscriptionTier) {
    case SubscriptionTier.Studio:
      return [
        projectsLocked,
        lowQualityExport,
        noCadImporters,
        previewOnly,
        noTeamMembers,
        noImmersive,
        noVersionHistory,
        noRenders,
      ];
    case SubscriptionTier.Individual:
      return [
        projectsLocked,
        lowQualityExport,
        previewOnly,
        noTeamMembers,
        noVersionHistory,
        noRenders,
      ];
    case SubscriptionTier.Lite:
    case SubscriptionTier.Pro:
    default:
      return [
        projectsLocked,
        lowQualityExport,
        previewOnly,
        noTeamMembers,
        noVersionHistory,
        limitedRenders,
      ];
  }
};
